// import { Button } from "@mui/material";
import { Button, Switch } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../../Config/baseUrl";
import AddSubSubMenu from "./AddSubSubMenu";
import SearchSelect from "../../../Shared/CustomSearchAndSelect";

export default function SubSubMenu() {
  const [data, setData] = useState([]);
  const [initialData, setInitailData] = useState(null);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const [menu, setMenu] = useState([]);
  const [searchmenu, setSearchMenu] = useState("");
  const [selectedmenu, setSelectedMenu] = useState("");

  const getMenu = () => {
    axios
      .get(
        `${baseUrl}/blog/sub-sub-menu-api/?search=${search}&sub_menu=${selectedmenu}`,
        {
          headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
          },
        },
      )
      .then((res) => {
        setData(res.data?.data);
      })
      .catch((err) => {
        toast.error("Error deleting blog", err?.response?.data?.message);
      });
  };
  const deleteFAQ = (id) => {
    axios
      .delete(`${baseUrl}/blog/sub-sub-menu-api/`, {
        data: { subsubmenu_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        getMenu();
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        toast.error("Error ", err?.response?.data?.message);
      });
  };
  const toggleStatus = (item) => {
    axios
      .patch(
        `${baseUrl}/blog/sub-sub-menu-api/`,
        {
          subsubmenu_id: item.id,
          is_active: !item.is_active,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
          },
        },
      )
      .then((res) => {
        toast.success(res?.data?.message);
        getMenu();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const togglePageDesign = (item) => {
    axios
      .patch(
        `${baseUrl}/blog/sub-sub-menu-api/`,
        {
          subsubmenu_id: item.id,
          is_active: !item.is_active,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
          },
        },
      )
      .then((res) => {
        toast.success(res?.data?.message);
        getMenu();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    getMenu();
  }, [search, selectedmenu]);

  const getMenuData = () => {
    axios
      .get(`${baseUrl}/blog/sub-menu-api/?search=${searchmenu}`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        setMenu(
          res?.data?.data?.map((item) => ({
            value: item.id,
            label: item.name,
          })),
        );
      })
      .catch((err) => {
        toast.error("Error in Fetching Data", err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getMenuData();
  }, [searchmenu]);

  return (
    <>
      <p className="my-3 sm:my-0 text-5xl text-center text-blue-900 underline">
        Sub Sub Menu
      </p>

      <div className="flex justify-between items-center px-1 pb-1 w-full">
        <div className="relative w-full max-w-sm">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full rounded-md border border-gray-300 px-4 py-2 text-sm 
                 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
          />
        </div>
        <div className=" flex items-center gap-3">
          <SearchSelect
            data={menu}
            value={selectedmenu}
            onSearch={(v) => setSearchMenu(v)}
            onChange={(value, option) => {
              setSelectedMenu(value);

              console.log("value:", value);
              console.log("option:", option);
            }}
            placeholder="Search Menu..."
          />
          <AddSubSubMenu
            getMenu={getMenu}
            initialData={initialData}
            setInitailData={setInitailData}
          />
        </div>
      </div>

      {/* Full-width table container */}
      <div className="w-full block overflow-x-auto">
        <table className="w-full border border-collapse border-gray-300 text-sm table-auto">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="px-2 py-1 font-semibold text-left text-black">
                #
              </th>

              <th className="px-2 py-1 font-semibold text-left text-black">
                Main Menu
              </th>
              <th className="px-2 py-1 font-semibold text-left text-black">
                Sub Menu
              </th>
              <th className="px-2 py-1 font-semibold text-left text-black">
                Sub Sub Menu
              </th>
              <th className="px-2 py-1 font-semibold text-left text-black">
                Image
              </th>
              <th className="px-2 py-1 font-semibold text-left text-black">
                Slider
              </th>
              <th className="px-2 py-1 font-semibold text-left text-black">
                Page
              </th>
              <th className="px-2 py-1 font-semibold text-center text-black">
                Status
              </th>
              <th className="px-2 py-1 font-semibold text-left text-black">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {data?.map((item, index) => (
              <tr key={item.id} className="border-b hover:bg-gray-100">
                <td className="px-2 py-1 whitespace-nowrap">{index + 1}</td>

                <td className="px-2 py-1 whitespace-nowrap">
                  <div className="cursor-pointer">{item?.main_menu_name}</div>
                </td>
                <td className="px-2 py-1 whitespace-nowrap">
                  <div className="cursor-pointer">{item?.sub_menu_name}</div>
                </td>
                <td className="px-2 py-1 whitespace-nowrap">
                  <div className="cursor-pointer">{item?.name}</div>
                </td>

                <td className="px-2 py-1">
                  <img
                    className="h-8 w-8 rounded object-cover border"
                    src={item?.image}
                    alt=""
                  />
                </td>

                <td className="px-2 py-1">
                  <div className="cursor-pointer">
                    {item?.slider_title || ""}
                  </div>
                </td>

                <td className="px-2 py-1">
                  <div className="cursor-pointer">{item?.page_title || ""}</div>
                </td>
                <td className="px-2 py-1 text-center">
                  <Switch
                    checked={item?.is_active}
                    onChange={() => toggleStatus(item)}
                    color="success"
                  />
                </td>
                <td className="px-2 py-1">
                  <div className="flex space-x-2">
                    <Button
                      onClick={() => setInitailData(item)}
                      variant="outlined"
                      size="small"
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => deleteFAQ(item.id)}
                      variant="outlined"
                      size="small"
                      color="error"
                    >
                      Delete
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
